import SVGIcon from 'components/SVGIcon/SVGIcon';
import React from 'react';
import TooltipIcon from './tooltipIcon.svg';

import { Button, Modal } from 'antd';
import styled from 'styled-components';
import translations from 'translations';
import utilMessages from 'utils/messages';

const AModal = styled(Modal)`
  .ant-modal-title {
    text-align: center !important;
    font-size: 20px !important;
    font-weight: 600 !important;
    line-height: 26px !important;
    color: #111827 !important;
  }
  .ant-modal-close {
    top: 16px !important;
  }
  .ant-modal-close-x {
    font-size: 18px !important;
  }
  .ant-modal-body {
    padding-inline: 6px;
  }
`;

const PolicyModalTitle = styled.h2`
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.32px;
  color: #111827;
`;

const PolicyModalMethodList = styled.ul`
  list-style-type: none;
  padding-left: 0;
  margin: 0;
`;

const PolicyModalMethodListItem = styled.li`
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
  color: #111827;
  padding-left: 20px;
  position: relative;

  &::before {
    content: '•';
    position: absolute;
    left: 10px;
    color: #333;
  }
`;

const PolicyModalDivider = styled.hr`
  border: none;
  margin: 12px 0;
`;

const PolicyModalButtonContainer = styled.div`
  margin-top: 24px !important;
  display: flex;
  justify-content: center;
`;
const PolicyModalButton = styled(Button)`
  width: 100%;
  height: 40px;
  font-weight: 500 !important;
  font-size: 16px !important;
  box-shadow: none !important;
`;

const ChargeBasedOnActualWeightIconModal = ({
  width = 15,
  height = 15,
  triggerGA4Event,
  children,
}: {
  width?: number;
  height?: number;
  triggerGA4Event?: () => void;
  children?: React.ReactNode;
}) => {
  const [openModal, setOpenModal] = React.useState(false);

  return (
    <>
      <div
        onClick={() => {
          setOpenModal(true);
          triggerGA4Event?.();
        }}
      >
        {children || (
          <SVGIcon src={TooltipIcon} width={width} height={height} renderAsImg={false} style={{ color: '#4b5563' }} />
        )}
      </div>
      <AModal
        destroyOnHidden={false}
        title={translations(utilMessages.paymentByUomKg)}
        closable={true}
        open={openModal}
        width={640}
        footer={null}
        onCancel={() => {
          setOpenModal(false);
        }}
      >
        <PolicyModalTitle>{translations(utilMessages.paymentByUomTitle1)}</PolicyModalTitle>
        <PolicyModalMethodList>
          <PolicyModalMethodListItem>{translations(utilMessages.paymentByUomTitle1Desc1)}</PolicyModalMethodListItem>
          <PolicyModalMethodListItem>{translations(utilMessages.paymentByUomTitle1Desc2)}</PolicyModalMethodListItem>
        </PolicyModalMethodList>

        <PolicyModalDivider isNoNeedBorder />
        <PolicyModalTitle>{translations(utilMessages.paymentByUomTitle2)}</PolicyModalTitle>
        <PolicyModalMethodList>
          <PolicyModalMethodListItem>
            {translations(utilMessages.paymentByUomTitle2Desc1)}
            <PolicyModalMethodList>
              <PolicyModalMethodListItem>
                {translations(utilMessages.paymentByUomTitle2Desc1SubDesc1)}
              </PolicyModalMethodListItem>

              <PolicyModalMethodListItem>
                {translations(utilMessages.paymentByUomTitle2Desc1SubDesc2)}
              </PolicyModalMethodListItem>
            </PolicyModalMethodList>
          </PolicyModalMethodListItem>

          <PolicyModalMethodListItem>{translations(utilMessages.paymentByUomTitle2Desc2)}</PolicyModalMethodListItem>
        </PolicyModalMethodList>
        <PolicyModalButtonContainer>
          <PolicyModalButton
            type="default"
            onClick={() => {
              setOpenModal(false);
            }}
          >
            {translations(utilMessages.gotItv2)}
          </PolicyModalButton>
        </PolicyModalButtonContainer>
      </AModal>
    </>
  );
};

export default ChargeBasedOnActualWeightIconModal;
